const getDefaultState = () => {
  return {
    preferenceSettingsOpen: false,
    currentSettingsTab: "Preferences",

    settingsOpen: false,

    customizerOpen: false,

    theme: "silver",

    styles: null,

    directMatchRequests: false,

    calendarPreferences: {
      prefer24HourFormat: true,
      preferRealTimeUpdates: true,
    },
  };
};

const state = getDefaultState();

// Synchronous
const mutations = {
  RESET_STATE(state) {
    // Merge rather than replace so we don't lose observers
    // https://github.com/vuejs/vuex/issues/1118
    Object.assign(state, getDefaultState());
  },

  TOGGLE_SETTINGS(state) {
    state.settingsOpen = !state.settingsOpen;
  },
  SET_SETTINGS_TAB(state, tab) {
    state.currentSettingsTab = tab;
  },
  SET_SETTINGS_OPEN(state, value) {
    state.settingsOpen = value;
  },

  TOGGLE_PREFERENCES(state) {
    state.preferenceSettingsOpen = !state.preferenceSettingsOpen;
  },
  TOGGLE_CUSTOMIZER(state) {
    state.customizerOpen = !state.customizerOpen;
  },
  SET_DIRECT_MATCH_REQUESTS(state, newValue) {
    state.directMatchRequests = newValue;
  },
  /**
   * @param {
   *  field: {String}
   *  newValue: {Boolean}
   * } payload
   */
  SET_CALENDAR_PREFERENCE_FIELD(state, payload) {
    state.calendarPreferences[payload.field] = payload.newValue;
  },
  SET_THEME(state, newTheme) {
    state.theme = newTheme;
  },
};

// Asynchronous
const actions = {
  resetState({ commit }) {
    commit("RESET_STATE");
  },
  togglePreferences({ commit }) {
    commit("TOGGLE_PREFERENCES");
  },
  toggleCustomizer({ commit }) {
    commit("TOGGLE_CUSTOMIZER");
  },
  setDirectMatchRequests({ commit }, newValue) {
    commit("SET_DIRECT_MATCH_REQUESTS", newValue);
    // TODO send to db
  },
  /**
   * @param {
   *  field: {String}
   *  newValue: {Boolean}
   * } payload
   */
  setCalendarPreferenceField({ commit }, payload) {
    commit("SET_CALENDAR_PREFERENCE_FIELD", payload);
  },
  setTheme({ commit }, newTheme) {
    commit("SET_THEME", newTheme);
  },
  /**
   * Add to store all the preferences right after login.
   */
  updateAfterLogin({ commit }, userPreferences) {
    if (userPreferences) {
      commit("SET_THEME", userPreferences.theme);
      commit("SET_DIRECT_MATCH_REQUESTS", userPreferences.directReqs);

      if (userPreferences.calendar) {
        commit("SET_CALENDAR_PREFERENCE_FIELD", {
          field: "prefer24HourFormat",
          newValue: userPreferences.calendar.format24hr,
        });
        commit("SET_CALENDAR_PREFERENCE_FIELD", {
          field: "preferRealTimeUpdates",
          newValue: userPreferences.calendar.realtime,
        });
      }
    }
  },
};

const cofocusPreferences = {
  namespaced: true,

  state,
  mutations,
  actions,
};

export default cofocusPreferences;
